import React, { useState, useEffect } from "react";
import { TextField, CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

const SearchLookupControl = ({
  label = "Search",
  lookupName,
  type,
  value,
  onChange,
  apiUrl,
  width = "50%",
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔁 Debounce input
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (inputValue) {
        fetchOptions(inputValue);
      } else {
        setOptions([]);
      }
    }, 400); // 400ms debounce

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  // 📡 API Call
  const fetchOptions = async (searchText) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}?lookupName=${lookupName}&type=${type}&search=${searchText}`
      );
      const data = await response.json();

      // Limit to top 20
      setOptions(data.slice(0, 20));
    } catch (error) {
      console.error("Lookup fetch error:", error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Autocomplete
  freeSolo
  options={options}
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option.label || ""
  }
  sx={{
    width,
    flex: "unset",
    mb: 2, // 👈 space below
  }}
  loading={loading}
  value={value}
  onChange={(event, newValue) => {
    onChange(newValue);
  }}
  inputValue={inputValue}
  onInputChange={(event, newInputValue) => {
    setInputValue(newInputValue);
  }}
  filterOptions={(x) => x}
  renderInput={(params) => (
    <TextField
      {...params}
      label={label}
      variant="outlined"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "20px", // 👈 rounded corners
        },
      }}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {loading && <CircularProgress size={20} />}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
/>
  );
};

export default SearchLookupControl;